<template>
    <basic-content-layout id="subscription-information-page" class="content">
        <catalog-page-header class="mb-5"></catalog-page-header>
        <section id="subscription-information-faq" itemscope itemtype ="https://schema.org/Article">
            <div class="container mb-5" v-if="!isLoading">
                <h1 class="display-2" itemprop="headline">{{ $t('pdb.whitelabel.content.about_subscription.title') }}</h1>
                <div class="row">
                    <div class="col-12 mb-3">
                        <span v-html="pageContent"></span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h2 class="display-2">{{ $t('faq.faq')}}</h2>
                    </div>
                    <div class="col-12">
                        <ul class="list-group">
                            <filter-collapse button-class="list-group-item" tag="li" v-for="(entry, index ) in entries "
                                :key="index" :visible="index === 0" v-if="$t(entry.title) != ''">
                                <template v-slot:button>
                                    <p class="mb-0"><b>{{ $t(entry.title) }}</b></p>
                                </template>
                                <template v-slot:collapse>
                                    <li class="list-group-item">
                                        <span v-html="$t(entry.text)"></span>
                                    </li>
                                </template>
                            </filter-collapse>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="container mb-5" v-if="isLoading">
                <b-skeleton width="40%" height="4.209rem" class="mb-5"></b-skeleton>
                <div class="row">
                    <div class="col-12 mb-3">
                        <b-skeleton width="60%" height="1rem"></b-skeleton>
                        <b-skeleton width="36%" height="1rem"></b-skeleton>
                        <b-skeleton width="45%" height="1rem"></b-skeleton>
                        <b-skeleton width="55%" height="1rem"></b-skeleton>
                    </div>
                </div>
            </div>
        </section>
    </basic-content-layout>
</template>
<script>
import BasicContentLayout from '../../layouts/BasicContentLayout.vue'
import CatalogPageHeader from "../../components/organisms/CatalogPageHeader.vue";
import { BSkeleton } from "bootstrap-vue";
import FilterCollapse from "../../components/molecules/FilterCollapse.vue";

export default {
    components: {
        BasicContentLayout,
        CatalogPageHeader,
        BSkeleton,
        FilterCollapse
    },
    data() {
        return {
            data: '',
            isLoading: true,
            error: false,
            meta_description: '',
            entries: [
                {
                    title: 'faq.title.requirements',
                    text: 'faq.text.requirements'
                },
                {
                    title: 'faq.title.payment_options',
                    text: 'faq.text.payment_options'
                },
                {
                    title: 'faq.title.getVehicle',
                    text: 'faq.text.getVehicle'
                }, {
                    title: 'faq.title.deterrent_fee',
                    text: 'faq.text.deterrent_fee'
                },
                {
                    title: 'faq.title.documents',
                    text: 'faq.text.documents'
                },
                {
                    title: 'faq.title.additional_driver',
                    text: 'faq.text.additional_driver'
                },
                {
                    title: 'faq.title.driver',
                    text: 'faq.text.driver'
                },
                {
                    title: 'faq.title.mileage',
                    text: 'faq.text.mileage'
                },
                {
                    title: 'faq.title.countries',
                    text: 'faq.text.countries'
                },
                {
                    title: 'faq.title.monthly_rate',
                    text: 'faq.text.monthly_rate'
                },
                {
                    title: 'faq.title.termination',
                    text: 'faq.text.termination'
                },
                {
                    title: 'faq.title.signs_of_wear',
                    text: 'faq.text.signs_of_wear'
                },
                {
                    title: 'faq.title.delivery_costs',
                    text: 'faq.text.delivery_costs'
                },
                {
                    title: 'faq.title.handover_documents',
                    text: 'faq.text.handover_documents'
                },
                {
                    title: 'faq.title.mileage_handover',
                    text: 'faq.text.mileage_handover'
                },
                {
                    title: 'faq.title.inspection',
                    text: 'faq.text.inspection'
                },
                {
                    title: 'faq.title.vehicle_registration',
                    text: 'faq.text.vehicle_registration'
                },
                {
                    title: 'faq.title.wheels',
                    text: 'faq.text.wheels'
                },
                {
                    title: 'faq.title.pickup',
                    text: 'faq.text.pickup'
                },
                {
                    title: 'faq.title.all_inclusive',
                    text: 'faq.text.all_inclusive'
                },
                {
                    title: 'faq.title.accident',
                    text: 'faq.text.accident'
                },
                {
                    title:'faq.title.business',
                    text: 'faq.text.business'
                },
                {
                    title: 'faq.title.return',
                    text: 'faq.text.return'
                },
            ]
        }
    },
    methods: {
        getContent() {
            this.error = false
            this.isLoading = true
            const language = this.$i18n.locale.startsWith('de-DE') ? 'de_DE' : this.$i18n.locale.substring(0, 2);


            this.$axios.post('api/v1/content/get_page', {
                slug: this.$t('route.about-subscription'),
                language: language
            })
                .then(response => {
                    this.isLoading = false
                    this.data = response.data.payload.data;
                    if (this.data.meta_description !== undefined) {
                        this.meta_description = this.data.meta_description;
                    }
                })
                .catch(error => {
                    this.error = true
                });
        },
        removeOldMetaDescription() {
            const el = document.querySelector("[name='description']");
            if (el !== null) {
                el.remove();
            }
        },
    },
    mounted() {
        this.getContent()
    },
    watch: {
        '$route.params.slug'() {
            this.getContent();
        },
        data() {
            if (this.data !== null){
                this.title = this.data.title
                this.$emit('updateHead')
            }
        }
    },
    computed: {
        pageContent() {
            return this.data ? JSON.parse(this.data.content).legal_text : ''
        },
    },
    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.$t('meta.aboutSubscription.title')
            }
        },
        meta: function () {
            this.removeOldMetaDescription();

            if (this.meta_description !== null) {
                return [
                    { name: 'description', content: this.meta_description },
                ]
            }
        }
    }
}
</script>
